<template>
  <div id="app">
    <!--    <img src="/static/assets/logo.png">-->
    <router-view/>
  </div>
</template>

<script>
  export default {
    name: 'App'
  }
</script>

<style>
  /* 全局字体设置，微软雅黑优先 */
  * {
    font-family: "Microsoft YaHei", "微软雅黑", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif !important;
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }
  #app {
    height: 100%;  /* 或者 100vh */
    width: 100%;
  }
  body{
    margin: 0!important;
    padding: 0;
    background-color: #F5F5F5; /* 浅灰色，常用页面底色 */
  }
</style>



// WEBPACK FOOTER //
// src/App.vue